import { CONSENT_REQUIRED_COUNTRIES } from '@constants'

export const isConsentRequiredCountry = (countryCode?: string | null) =>
  Boolean(countryCode && CONSENT_REQUIRED_COUNTRIES.includes(countryCode.toUpperCase()))
